var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsString, IsUUID, Matches, ValidateNested } from 'class-validator';
import { WorkingBlockDto } from './working-block.dto.js';
export class CreateWorkingScheduleDto {
    userId;
    officeLocationId;
    validFrom;
    blocks;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateWorkingScheduleDto.prototype, "userId", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateWorkingScheduleDto.prototype, "officeLocationId", void 0);
__decorate([
    IsString(),
    Matches(/^\d{4}-\d{2}-\d{2}$/, { message: 'validFrom must be in "YYYY-MM-DD" format' }),
    __metadata("design:type", String)
], CreateWorkingScheduleDto.prototype, "validFrom", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => WorkingBlockDto),
    __metadata("design:type", Array)
], CreateWorkingScheduleDto.prototype, "blocks", void 0);
//# sourceMappingURL=create-working-schedule.dto.js.map